function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.392 12.574a9.106 9.106 0 013.745 7.711h.964a.317.317 0 01.32.321v.643a.317.317 0 01-.32.321H4.32A.317.317 0 014 21.25v-.643a.317.317 0 01.321-.32h.964a9.106 9.106 0 013.745-7.712 9.106 9.106 0 01-3.745-7.71h-.964A.317.317 0 014 4.541v-.643a.317.317 0 01.321-.32h14.78a.317.317 0 01.32.32v.643a.317.317 0 01-.32.321h-.964a9.106 9.106 0 01-3.745 7.711zM6.57 4.864a8.9 8.9 0 00.854 3.855h8.574a8.9 8.9 0 00.854-3.856zm6.296 8.353h-2.31a6.661 6.661 0 00-3.413 3.855h9.136a6.661 6.661 0 00-3.413-3.855z"
});

function SvgSpMenuTimeline(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "spMenuTimeline.b145d.svg";
export { SvgSpMenuTimeline as ReactComponent };